import React from 'react';

import * as S from './styles';

const CloseButton = ({ onClick, className }) =>
    <S.CloseButton onClick={ onClick } className={ className } />;

export default CloseButton;
